const intialState = {
  captcha: false,
  captchaToken: null,
  Spiiner: "Stop",
  Username: "",
  Lastname: "",
  ClientId: "",
  Designation: "",
  Email: "",
  Countries: "",
  Country_state: "",
  Pincode: "",
  Companyname: "",
  Contact: "",
  LoginId: "",
  Password: "",
  Token: "",
  Website: "",
  Remark: "",
  alert: false,
  alertmsg: "",
  alertheadermsg: "Alert !",
  alertConfirmMsg: "",
  OrgTable: null,
  OrgList: null,
  UserRoleMapProductDetails: null,
  EnquiryList: null,
  EnquiryListReject: null,
  SubscriptionDetails: null,
  SubscriptionUserDetails: null,
  SubscriptionUserMaprole: null,
  Rolemaster: null,
  Planmaster: null,
  ProductModal: false,
  Productmaster: null,
  ProductList: null,
  Li_details: null,
  EnquiryLicensedetails: {
    ProdName: "",
    Domain: "",
    ProdId: "",
    PlanId: "",
    PlanName: "",
    Cost: "",
    Currency: "",
    Frequency: "",
    PlanCap: "",
  },
  Super_UserCreation: false,
  Super_usercreation_store: {
    Product: null,
    Firstname: "",
    Lastname: "",
    Email: "",
    Phone: "",
    Department: "",
  },
  EnquiryOrgdetails: {
    AdminDepartment: "",
    AdminEmail: "",
    countrycode:"",
    AdminPhone: "",
    AdminLastname: "",
    AdminFirstname: "",
    ClientCompanyName: "",
    ClientAddress1: "",
    ClientAddress2: "",
    ClientCity: "",
    ClientCountry: "",
    ClientState: "",
    ClientPincode: "",
    ClientCountryCode: "",
    ClientContactName: "",
    ClientDesignation: "",
    CurrencyCode: "",
    ClientType: "",
    NatureOfBusiness: "",
    BusinessVertical: "",
    ClientRevenueInUSD: "",
    ContactName: "",
    ContactDesignation: "",
    ContactEmail: "",
    ContactPhone: "",
    EnquiryModel: false,
    Product: null,
  },
  buttonclick: true,
  SelectedData: null,
  code: "",
  AddProduct: false,
  twofacoteruserdata: [],
  orgusercreation: {
    firstname: "",
    lastname: "",
    email: "",
    deparmentname: "",
    deparmentcode: "",
    phone: "",
  },
  activeuserslist: null,
  orgactiveuserslist: null,
  fulluserslist: null,
  userrole: null,
  disablefulluser: false,
  disableprojecttouser: false,
  Activedisableclientid: null,
  singleuserprojectdata: null,
  disableuserslist: null,
  usercreationboxopen: false,
  defaultuseraction: null,
  sso: null,
  OrgApprovesetting: null,
  SuperorgApprovesetting: null,
  Superitsmgrp: null,
  Groupmaping: null,
  OrgGroupmaping: null,
  Superitsmgrporg: null,
  ProjectMaster: null,
  OrgprojectMaster: null,
  OnboardedUserlist: null,
  SubscriptionDetailsPromote: null,
  UserSessions: null,
  OrgUserSessions: null,
};
export default intialState;
